import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css"
import {add,remove} from "../redux/Slices/cartSlice"
import { useEffect } from "react";

const Product = (props) => {
  
  const product=props.product;
  const dispatch=useDispatch();
  const removeFromTheItem=()=>{
    dispatch(remove(product.id))
    toast.error("Item removed")

  }
  const addToCart=()=>{
    dispatch(add(product))
    toast.success("Item added successfully");
  }

 
  const {Cart}=useSelector((state)=> state);
  return <div className="group hover:scale-110 transition duration-300 ease-in flex flex-col items-center justify-between shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:shadow-[0px_0px_95px_53px_#00000024] gap-3 p-4 mt-10 ml-5  rounded-xl">
    <div>
      <h1 className="font-semibold text-center text-lg">{product.title.substring(0,17)}...</h1>
    </div>
    <div>
      <p className="text-[12px] text-gray-400">
        {product.description.substring(0,100)}...
      </p>
    </div>
    <div>
      <img src={product.image} className=" h-[180px]" alt="" />
    </div>
    <div className="flex justify-between gap-8">
      <p className="text-green-500 items-center ">${product.price}</p>
      {
          Cart.some((p)=> p.id == product.id)?
          (
            <button className="border rounded-2xl px-3 py-1 border-black text-sm group-hover:bg-slate-950 group-hover:text-white" onClick={removeFromTheItem}>Remove</button>
          ):
          (
            <button className="border rounded-2xl px-3 py-1 border-black text-sm group-hover:bg-slate-950 group-hover:text-white" onClick={addToCart}>
              Add to Cart
            </button>
          ) }

      
     
    </div>

  </div>;
};

export default Product;
